<template>
  <div class="retake--wrap">
    <content-box v-if="state === 'beforeRequest'"
                  class="state__before"
                  :width="'430px'"
                  :height="'290px'">
      <ui-loading-circle>
        <span v-html="$t('lnb.claimIssue.retake.bLoginTrue.ing.desc')"></span>
      </ui-loading-circle>
    </content-box>
    <content-box v-else-if="state === 'ing'"
                 class="state__ing"
                 :width="'600px'">
      <i class="icon icon--camera-size70"></i>
      <p class="title" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.title')"></p>
      <div class="loading--wrap">
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
      </div>
      <p class="desc" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.desc')"></p>
      <div class="tip--wrap">
        <i class="text-tip">Tip !</i>
        <swiper :options="swiperOption" ref="swiperWrap">
          <swiper-slide class="list1">
            <div class="content--wrap">
              <div class="question">
                <i class="icon icon--user"></i>
                <div class="text--wrap">
                  <p v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list1.question')"></p>
                </div>
              </div>
              <div class="answer">
                <div class="text--wrap">
                  <p>
                    <span class="first" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list1.answer')"></span>
                  </p>
                  <figure class="img__capture" :class="$i18n.locale"></figure>
                  <span>
                    <span class="first-text" v-html="$t('common.uxAnalysisImage')"></span>
                    <span class="second-text" v-html="$t('common.heatmapImage')"></span>
                    <span class="third-text" v-html="$t('common.captureImage')"></span>
                  </span>
                </div>
                <i class="icon icon--logo-mini"></i>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="list2">
            <div class="content--wrap">
              <div class="question">
                <i class="icon icon--user"></i>
                <div class="text--wrap">
                  <p v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list2.question')"></p>
                </div>
              </div>
              <div class="answer">
                <div class="text--wrap">
                  <p>
                    <span class="first" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list2.answer')"></span>
                    <span class="ex-text" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list2.ex')"></span>
                  </p>
                  <figure class="img__css" :class="$i18n.locale"></figure>
                </div>
                <i class="icon icon--logo-mini"></i>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="list3">
            <div class="content--wrap">
              <div class="question">
                <i class="icon icon--user"></i>
                <div class="text--wrap">
                  <p v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list3.question')"></p>
                </div>
              </div>
              <div class="answer">
                <div class="text--wrap">
                  <p>
                    <span class="first" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list3.answer')"></span>
                  </p>
                  <figure class="img__bLogin" :class="$i18n.locale"></figure>
                </div>
                <i class="icon icon--logo-mini"></i>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="list4">
            <div class="content--wrap">
              <div class="question">
                <i class="icon icon--user"></i>
                <div class="text--wrap">
                  <p v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list4.question')"></p>
                </div>
              </div>
              <div class="answer">
                <div class="text--wrap">
                  <p>
                    <span class="first" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list4.answer')"></span>
                  </p>
                  <figure class="img__bMobile" :class="$i18n.locale"></figure>
                </div>
                <i class="icon icon--logo-mini"></i>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination" ref="pagination"></div>
          <div class="swiper-button-prev icon icon--prev-gray-size20" slot="button-prev"></div>
          <div class="swiper-button-next icon icon--prev-gray-size20" slot="button-next"></div>
        </swiper>
      </div>
    </content-box>
    <content-box v-else-if="state === 'failed'"
                  class="state__fail"
                  :width="'430px'">
      <i class="icon icon--camera-error-size50"></i>
      <p class="title">{{ $t('lnb.claimIssue.retake.bLoginFalse.fail.title') }}</p>
      <p class="desc">{{ $t('lnb.claimIssue.retake.bLoginFalse.fail.desc') }}</p>
      <ui-button
        @click="onCloseLayer">{{ $t('common.confirm') }}</ui-button>
    </content-box>
    <content-box v-else-if="state === 'error'"
                 class="state__fail"
                 :width="'430px'">
      <i class="icon icon--camera-error-size50"></i>
      <p class="title">{{ $t('lnb.claimIssue.retake.bLoginFalse.error.title') }}</p>
      <p class="desc">{{ $t('lnb.claimIssue.retake.bLoginFalse.error.desc') }}</p>
      <ui-button
        @click="onCloseLayer">{{ $t('common.confirm') }}</ui-button>
    </content-box>
  </div>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import UiButton from '@/components/ui/UiButton'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { requestCapture, getCaptureStatus } from '@/api/capture'
import { CAPTURE_SUCCESS } from '@/libs/apply-helper'

export default {
  components: {
    ContentBox,
    UiLoadingCircle,
    UiButton,
    swiper,
    swiperSlide
  },
  props: [
    'aid'
  ],
  data () {
    return {
      state: 'beforeRequest', // beforeRequest, ing, success, failed, error
      swiperLayoutWidth: 560,
      swiperOption: {
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created () {
    this.aidList = []
    this.aidList.push({
      aid: this.aid,
      state: '',
      timer: null,
      bAB: false
    })

    if (this.$route.params.abAid) {
      this.aidList.push({
        aid: this.$route.params.abAid,
        state: '',
        timer: null,
        bAB: true
      })
    }

    this.aidList.forEach((aid, index) => {
      this.captureRequest(aid, index)
    })
  },
  methods: {
    captureRequest (aid, index) {
      requestCapture(aid.aid, aid.bAB).then(data => {
        return data
      }).then(data => {
        const requestId = data.requestId
        const uuid = data.uuid

        if (index === this.aidList.length - 1) {
          this.state = 'ing'
        }

        this.$nextTick().then(() => {
          if (index === 0) {
            this.initSwiper()
          }
        })

        this.aidList[index].timer = setInterval(() => {
          getCaptureStatus(requestId, uuid, true).then(tasks => {
            if (!tasks.length) {
              throw new Error('no tasks')
            }

            let successCount = 0
            let failedCount = 0

            for (const item of tasks) {
              if (item.statusCode === CAPTURE_SUCCESS) {
                successCount++
              } else if (item.statusCode < 0) {
                failedCount++
              }

              if (successCount + failedCount === tasks.length) {
                clearInterval(this.aidList[index].timer)

                if (successCount === 0) {
                  this.aidList[index].state = 'failed'

                  let failedCheck = true
                  this.aidList.forEach(item => {
                    if (item.state !== 'failed') {
                      failedCheck = false
                    }
                  })

                  if (failedCheck) {
                    this.state = 'failed'
                  }
                } else {
                  this.aidList[index].state = 'success'

                  let successCheck = true
                  this.aidList.forEach(item => {
                    if (item.state !== 'success') {
                      successCheck = false
                    }
                  })

                  if (successCheck) {
                    this.state = 'success'
                    this.$emit('onCaptureSuccess', tasks)
                  }
                }
              }
            }
          }).catch(err => {
            throw err
          })
        }, 5000)
      }).catch(err => {
        clearInterval(this.timer)
        this.state = 'error'
        console.error(err)
      })
    },
    onCloseLayer () {
      this.$emit('closeLayer')
    },
    initSwiper () {
      const swiperWrapperWidth = this.swiperLayoutWidth * this.$refs.swiperWrap.$children.length
      const swiperWrapper = document.querySelector('.retake--wrap .swiper-wrapper')
      swiperWrapper.setAttribute('style', `width:${swiperWrapperWidth}px`)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.retake--wrap {
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #444444;
  }
  .desc {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;
  }

  & > [class*=state__] {
    text-align: center;
    position: relative;
    box-sizing: border-box;
  }

  .state__before {
    /deep/ .loading.position {
      top: 100px;
      transform: translate(-50%, 0);
      .desc {
        white-space: nowrap;
        font-size: 14px;
        color: #2f2f2f;
      }
    }
  }

  .state__ing {
    padding: 20px;
    .icon--camera-size70 {
      margin-top: 30px;
    }
    .title {
      color: $brandColor;
      margin-top: 11px;
    }
    .desc {
      line-height: 1.5;
      color: #444444;
      margin-top: 27px;

      span {
        color: $brandColor;
      }
    }
    .loading--wrap {
      width: 180px;
      height: 12px;
      margin: 18px auto 0;

      .loading-bar {
        display: block;
        position: absolute;
        padding: 6px;
        border-radius: 50%;
        background-color: $brandColor;
        animation: loading 1.4s ease-in-out 0s infinite;

        &:nth-child(1) {
          animation-delay: 0s;
        }
        &:nth-child(2) {
          animation-delay: 0.15s;
        }
        &:nth-child(3) {
          animation-delay: 0.3s;
        }
        &:nth-child(4) {
          animation-delay: 0.45s;
        }
        &:nth-child(5) {
          animation-delay: 0.6s;
        }
      }
    }
    .tip--wrap {
      position: relative;
      margin: 20px auto 0;
      box-sizing: border-box;
      width: 560px;
      height: 385px;
      border-radius: 8px;
      border: solid 1px #d7d7d7;
      background-color: #ebebeb;
      overflow: hidden;

      .swiper-container {
        height: 100%;

        /deep/ .swiper-wrapper {
          white-space: nowrap;
          height: 100%;
        }
        .swiper-slide {
          position: relative;
          display: inline-block;
          vertical-align: top;
          height: 100%;

          & > div {
            @include positionYcenter;
            width: 100%;
            padding: 0 40px;
            box-sizing: border-box;
          }
        }
      }

      /deep/ .swiper-pagination {
        width: 100%;
        left: 0;
        bottom: 10px;

        position: absolute;
        text-align: center;
        transition: opacity .3s;
        transform: translateZ(0);
        z-index: 10;

        .swiper-pagination-bullet {
          margin: 0 4px;
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 100%;
          background-color: #000;
          opacity: 0.15;
          cursor: pointer;

          &.swiper-pagination-bullet-active {
            background-color: #ffffff;
            opacity: 1;
            box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.15);
          }
        }
      }
      .swiper-button-next, .swiper-button-prev {
        @include positionYcenter;
        z-index: 10;
        cursor: pointer;
        padding: 10px;
        background-position: center;
      }
      .swiper-button-prev {
        left: 0px;
        right: auto;
      }
      .swiper-button-next {
        right: 0px;
        left: auto;
        transform: rotate(180deg) translateY(50%);
      }

      i.text-tip {
        display: inline-block;
        width: 37px;
        height: 20px;
        line-height: 22px;
        border-radius: 4px;
        background-color: #43b6c9;

        font-size: 12px;
        font-weight: bold;
        color: #ffffff;

        position: absolute;
        top: 8px;
        left: 8px;
      }

      .text--wrap {
        display: inline-block;
        font-size: 13px;
        font-weight: bold;
        box-shadow: 0 7px 6px -4px rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.3);
        border-radius: 16px;
      }

      .question {
        text-align: left;

        .icon {
          width: 32px;
          height: 32px;
          background-color: #fff;
          background-position: center;
          border-radius: 11px;
          box-shadow: 0 7px 6px -4px rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.3);
          vertical-align: top;
          margin: 0;
          margin-right: 8px;
        }
        .text--wrap {
          color: #2f2f2f;
          background-color: #ffffff;
          border-top-left-radius: 0;
          min-height: 35px;
          line-height: 35px;
          padding-left: 15px;
          padding-right: 17px;
          padding-top: 7.5px;
          padding-bottom: 8px;
          box-sizing: border-box;

          p {
            line-height: 1.5;
          }
        }
      }

      /deep/ .answer {
        text-align: right;
        margin-top: 20px;

        .icon {
          width: 32px;
          height: 32px;
          border-radius: 11px;
          box-shadow: 0 7px 6px -4px rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.3);
          background-color: #ffffff;
          background-position: center;
          vertical-align: top;
          margin-left: 8px;
        }
        .text--wrap {
          background-color: #2f2f2f;
          font-size: 13px;
          font-weight: bold;
          line-height: 1.54;
          color: #ffffff;
          border-top-right-radius: 0;
          padding-top: 20px;
          padding-left: 22px;
          padding-bottom: 30px;
          padding-right: 22px;
          position: relative;
          width: 380px;
          box-sizing: border-box;
          white-space: normal;
          text-align: left;

          p {
            text-align: left;
            display: inline-block;
            span {
              display: inline-block;
              &:not(.first) {
                margin-top: 20px;
              }
            }
            strong {
              color: #ffd100;
            }
            .ex-text {
              color: #d7d7d7;
            }
          }

          figure {
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;

            &.img__capture {
              width: 304px;
              height: 80px;
              margin: 20px auto 12px;

              &.ko {
                background-image: url('../../assets/img/page/regi_guide_2-7_ko.png');
              }
              &.ja {
                background-image: url('../../assets/img/page/regi_guide_2-7_ja.png');
              }
              &.en {
                background-image: url('../../assets/img/page/regi_guide_2-7_en.png');
              }

              & + span {
                display: block;
                margin: 0 auto;
                width: 304px;
                font-size: 12px;
                font-weight: bold;
                color: #d7d7d7;
                white-space: nowrap;

                span {
                  display: inline-block;
                  width: 83px;
                  text-align: center;
                  &.first-text {
                    margin-right: 28px;
                  }
                  &.second-text {
                    margin-right: 28px;
                  }
                  &.third-text {
                    color: #ffd100;
                  }
                }
              }
            }
            &.img__css {
              width: 274px;
              height: 80px;
              margin-top: 20px;

              &.ko {
                background-image: url('../../assets/img/page/regi_guide_3-3_ko.png');
              }
              &.ja {
                background-image: url('../../assets/img/page/regi_guide_3-3_ja.png');
              }
              &.en {
                background-image: url('../../assets/img/page/regi_guide_3-3_en.png');
              }
            }
            &.img__bLogin {
              width: 256px;
              height: 97px;
              margin: 28px auto 0;

              &.ko {
                background-image: url('../../assets/img/page/regi_guide_2-8_ko.png');
              }
              &.ja {
                background-image: url('../../assets/img/page/regi_guide_2-8_ja.png');
              }
              &.en {
                background-image: url('../../assets/img/page/regi_guide_2-8_en.png');
              }
            }
            &.img__bMobile {
              width: 320px;
              height: 121px;
              margin: 15px auto 0;

              &.ko {
                background-image: url('../../assets/img/page/regi_guide_2-9_ko.png');
              }
              &.ja {
                background-image: url('../../assets/img/page/regi_guide_2-9_ja.png');
              }
              &.en {
                background-image: url('../../assets/img/page/regi_guide_2-9_en.png');
              }
            }
          }
        }
      }
    }
  }

  .state__fail {
    padding-top: 50px;
    padding-bottom: 25px;
    .title {
      margin-top: 15px;
    }
    .desc {
      margin-top: 12px;
    }
    .ui-btn {
      margin-top: 60px;
    }
  }
}
@keyframes loading {
  0% {
    transform: translateX(-15px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(180px);
    opacity: 0;
  }
}

@-webkit-keyframes loading {
  0% {
    transform: translateX(-15px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(180px);
    opacity: 0;
  }
}
</style>
